import Vue from 'vue';
import Router from 'vue-router';
// import { routeList } from './routeList'

Vue.use(Router);



export default new Router({
	routes: [
		// 登录
		{ path: '/login', name: 'login', title: '登录', component: () => import(`@/views/login/App.vue`) },
		// 注册
		{ path: '/register', name: 'register', title: '注册', component: () => import(`@/views/register/App.vue`) },
		{ path: '/registerInfo', name: 'registerInfo', title: '注册填写资料', component: () => import(`@/views/register/registerInfo.vue`) },
		
		// ...routeList
		// 401
		{ path: '/401', name: '401', title: '无权访问', component: () => import (`@/views/404/401.vue`) },
		// 404
		{ path: '/404', name: '404', title: '404', component: () =>import(`@/views/404/404.vue`) },
		
	]
})



